module.exports = __webpack_public_path__ + "img/9f004d7f-cb06-48ed-963f-08893d72a04b.29d18181.png";